import { useListOrder } from '../../filter';
import { RoutineOrderKey } from '../domain';

export const useRoutineListOrder = () => {
  return useListOrder(RoutineOrderKey, 'routineOrderBy', true);
};
